import { useEffect } from 'react';

export function useWorkerState(
  worker: ServiceWorker | null | undefined,
  callback: (worker: ServiceWorker) => void,
  dependencies: unknown[] = [],
) {
  // biome-ignore lint/correctness/useExhaustiveDependencies: callback doesn't change
  useEffect(() => {
    if (!worker) return;

    return callback(worker);
  }, [worker, worker?.state, ...dependencies]);
}
